/*
 * Copyright 2024 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-wallet/blob/master/LICENSE.md
 */
package org.mifospay.feature.mpay.qr.scan.navigation

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import org.mifospay.core.model.utils.QrCodeData
import org.mifospay.core.ui.composableWithSlideTransitions
import org.mifospay.feature.mpay.qr.scan.ScanQrCodeScreen

const val SCAN_QR_ROUTE = "scan_qr_route"

fun NavController.navigateToScanQr(navOptions: NavOptions? = null) =
    navigate(SCAN_QR_ROUTE, navOptions)

fun NavGraphBuilder.scanQrScreen(
    navigateBack: () -> Unit,
    navigateToIntraBankTransfer: (QrCodeData) -> Unit,
    navigateToInterbankTransfer: (accountExternalId: String, recipientName: String, amount: String) -> Unit,
    navigateToAddBeneficiaryScreen: (String) -> Unit,
) {
    composableWithSlideTransitions(route = SCAN_QR_ROUTE) {
        ScanQrCodeScreen(
            navigateBack = navigateBack,
            navigateToIntraBankTransfer = navigateToIntraBankTransfer,
            navigateToInterbankTransfer = navigateToInterbankTransfer,
            navigateToAddBeneficiaryScreen = navigateToAddBeneficiaryScreen,
        )
    }
}
